// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"4":"93b241c7","856":"ce9e4ce1"}[chunkId] + ".js";
};